<template>
  <el-dialog
    title="车次修改"
    :visible.sync="dialogVisible"
    width="800px"
    @close="handleClose"
  >
    <el-form
      ref="changeForm"
      :model="formData"
      :rules="rules"
      label-width="150px"
      v-loading="loading"
    >
      <el-form-item label="原始线路">
        <el-input v-model="trainInfo.org_bus_tit" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="数据源">
        <el-input v-model="trainInfo.source" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="出发日期">
        <el-input v-model="trainInfo.date" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="巴士公司订单号">
        <el-input v-model="trainInfo.ticket_sn" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="预留电话">
        <el-input v-model="trainInfo.ticket_tel" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="支付状态">
        <el-input v-model="trainInfo.ticket_pay" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="原始金额(日元)">
        <el-input-number v-model="trainInfo.ticket_org_amount" :disabled="true" style="width: 100%"></el-input-number>
      </el-form-item>

      <el-form-item label="起点站" prop="start_point_i">
        <el-select v-model="formData.start_point_i" placeholder="请选择起点站" style="width: 100%">
          <el-option
            v-for="(station, index) in trainInfo.stats"
            :key="index"
            :label="station"
            :value="String(index)"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="终点站" prop="end_point_i">
        <el-select v-model="formData.end_point_i" placeholder="请选择终点站" style="width: 100%">
          <el-option
            v-for="(station, index) in trainInfo.ends"
            :key="index"
            :label="station"
            :value="String(index)"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="起点关键字" prop="start_key">
        <el-input v-model="formData.start_key" placeholder="请输入起点关键字"></el-input>
      </el-form-item>

      <el-form-item label="终点关键字" prop="end_key">
        <el-input v-model="formData.end_key" placeholder="请输入终点关键字"></el-input>
      </el-form-item>

      <el-form-item label="新订票金额(日元)" prop="ticket_org_amount">
        <el-input-number
          v-model="formData.ticket_org_amount"
          :precision="2"
          :min="0"
          style="width: 100%"
          placeholder="请输入新的订票金额"
        ></el-input-number>
      </el-form-item>

      <!-- 联系人信息 -->
      <div v-if="trainInfo.contacts && trainInfo.contacts.length > 0">
        <h4 style="margin: 20px 0 10px 0; color: #606266;">联系人信息</h4>
        <el-form-item
          v-for="contact in trainInfo.contacts"
          :key="contact.id"
          :label="`${contact.name} ${contact.sex} ${contact.age}`"
          :prop="`contact_${contact.id}`"
          :rules="contact.status === 1 ? [{ required: true, message: '请输入日文姓名', trigger: 'blur' }] : []"
        >
          <el-input
            v-if="contact.status === 1"
            v-model="formData[`contact_${contact.id}`]"
            placeholder="请输入日文姓名"
          ></el-input>
          <span v-else style="color: #909399;">已退款</span>
        </el-form-item>
      </div>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ChangeTrainDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      submitting: false,
      trainInfo: {
        org_bus_tit: '',
        source: '',
        date: '',
        ticket_sn: '',
        ticket_tel: '',
        ticket_pay: '',
        ticket_note: '',
        ticket_org_amount: 0,
        source_data: {},
        contacts: [],
        stats: [],
        ends: [],
        start_point_i: '',
        end_point_i: '',
        start_key: '',
        end_key: ''
      },
      formData: {
        start_point_i: '',
        end_point_i: '',
        start_key: '',
        end_key: '',
        ticket_org_amount: 0
      },
      rules: {
        start_point_i: [
          { required: true, message: '请选择起点站', trigger: 'change' }
        ],
        end_point_i: [
          { required: true, message: '请选择终点站', trigger: 'change' }
        ],
        start_key: [
          { required: true, message: '请输入起点关键字', trigger: 'blur' }
        ],
        end_key: [
          { required: true, message: '请输入终点关键字', trigger: 'blur' }
        ],
        ticket_org_amount: [
          { required: true, message: '请输入订票金额', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal && this.orderId) {
        this.loadFormData()
      }
    },
    dialogVisible(newVal) {
      if (!newVal) {
        this.$emit('update:visible', false)
      }
    }
  },
  methods: {
    async loadFormData() {
      if (!this.orderId) return
      
      this.loading = true
      try {
        const response = await axios.get(`${this.base_url}/orders/${this.orderId}/change-train/form`)
        if (response.status === 200 && response.data.code) {
          const data = response.data.data
          this.trainInfo = {
            org_bus_tit: data.org_bus_tit || '',
            source: data.source || '',
            date: data.date || '',
            ticket_sn: data.ticket_sn || '',
            ticket_tel: data.ticket_tel || '',
            ticket_pay: data.ticket_pay || '',
            ticket_note: data.ticket_note || '',
            ticket_org_amount: data.ticket_org_amount || 0,
            source_data: data.source_data || {},
            contacts: data.contacts || [],
            stats: data.stats || [],
            ends: data.ends || [],
            start_point_i: data.start_point_i || '',
            end_point_i: data.end_point_i || '',
            start_key: data.start_key || '',
            end_key: data.end_key || ''
          }
          
          // 初始化表单数据
          this.formData = {
            start_point_i: data.start_point_i || '',
            end_point_i: data.end_point_i || '',
            start_key: data.start_key || '',
            end_key: data.end_key || '',
            ticket_org_amount: data.ticket_org_amount || 0
          }
          
          // 初始化联系人字段
          if (this.trainInfo.contacts) {
            this.trainInfo.contacts.forEach(contact => {
              if (contact.status === 1) {
                this.$set(this.formData, `contact_${contact.id}`, contact.jp_name || '')
              }
            })
          }
        } else {
          this.$message.error(response.data.message || '获取表单数据失败')
        }
      } catch (error) {
        console.error('获取表单数据失败:', error)
        this.$message.error('获取表单数据失败')
      } finally {
        this.loading = false
      }
    },

    async handleSubmit() {
      this.$refs.changeForm.validate(async (valid) => {
        if (valid) {
          this.submitting = true
          try {
            const submitData = { ...this.formData }
            
            // 添加联系人数据
            if (this.trainInfo.contacts) {
              this.trainInfo.contacts.forEach(contact => {
                if (contact.status === 1 && this.formData[`contact_${contact.id}`]) {
                  submitData[`contact_${contact.id}`] = this.formData[`contact_${contact.id}`]
                }
              })
            }
            
            const response = await axios.post(`${this.base_url}/orders/${this.orderId}/change-train/submit`, submitData)
            if (response.status === 200 && response.data.code) {
              this.$message.success('车次修改成功')
              this.dialogVisible = false
              this.$emit('success')
            } else {
              this.$message.error(response.data.message || '车次修改失败')
            }
          } catch (error) {
            console.error('车次修改失败:', error)
            this.$message.error('车次修改失败')
          } finally {
            this.submitting = false
          }
        } else {
          this.$message.error('请检查表单填写是否正确')
        }
      })
    },

    handleClose() {
      this.dialogVisible = false
      this.resetForm()
    },

    resetForm() {
      this.$refs.changeForm && this.$refs.changeForm.resetFields()
      this.formData = {
        start_point_i: '',
        end_point_i: '',
        start_key: '',
        end_key: '',
        ticket_org_amount: 0
      }
      this.trainInfo = {
        org_bus_tit: '',
        source: '',
        date: '',
        ticket_sn: '',
        ticket_tel: '',
        ticket_pay: '',
        ticket_note: '',
        ticket_org_amount: 0,
        source_data: {},
        contacts: [],
        stats: [],
        ends: [],
        start_point_i: '',
        end_point_i: '',
        start_key: '',
        end_key: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  text-align: right;
}

.el-form {
  .el-select {
    width: 100%;
  }
}
</style>